import { FC } from 'react';

import { RequiredRule } from 'devextreme-react/form';
import { DropDownOptions } from 'devextreme-react/select-box';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import { DateBox, SelectBox, TextArea, Validator } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import { DriverPumpAdjustmentsItem } from 'bus/driverPumpAdjustments/types';

import { getDefaultFilter } from '../../utils';

type Props = {
  form: DriverPumpAdjustmentsItem;
  onChange: (
    name: keyof DriverPumpAdjustmentsItem,
    value: DriverPumpAdjustmentsItem[keyof DriverPumpAdjustmentsItem],
  ) => void;
  type: 'driver' | 'mixer' | 'employee' | 'pump';
};

export const DriverSalaryAdjustmentsForm: FC<Props> = ({ form, onChange, type }) => {
  const storeEmployee = $createDataSource('/v1/employee', 'id', {
    defaultFilter: getDefaultFilter(type),
    defaultSort: [{ selector: 'fullName', desc: false }],
  });

  return (
    <AppRow className="mt-2">
      <AppGroup col={12}>
        <AppFiledBox label="Дата" labelTop>
          <DateBox
            stylingMode="underlined"
            type="date"
            onValueChange={(e) => {
              onChange('date', e as string);
            }}
            useMaskBehavior
            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
            value={form.date}
          >
            <Validator>
              <RequiredRule message="Заполните поле дата" />
            </Validator>
          </DateBox>
        </AppFiledBox>

        <AppFiledBox label={type === 'employee' ? 'Контрагент' : 'Водитель'} labelTop>
          <SelectBox
            stylingMode="underlined"
            dataSource={storeEmployee}
            displayExpr="fullName"
            valueExpr="id"
            value={form.driverId}
            searchEnabled
            onValueChange={(e) => {
              onChange('driverId', e);
            }}
          >
            <DropDownOptions title="Выберите Водитель" closeOnOutsideClick={true} showTitle={false} />
            <Validator>
              <RequiredRule message="Выберите Водитель" />
            </Validator>
          </SelectBox>
        </AppFiledBox>

        <AppFiledBox label="Комментарий" labelTop>
          <TextArea
            stylingMode="underlined"
            placeholder="Введите комментарий"
            mode="text"
            value={form.comment || ''}
            onValueChange={(e) => {
              onChange('comment', e);
            }}
            height={90}
          />
        </AppFiledBox>
      </AppGroup>
    </AppRow>
  );
};
